module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "speaker columns"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteWebinar(_vm.webinarObject.id)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', [_c('b-field', {
    staticClass: "count-wrapper",
    attrs: {
      "label": "Количество мест"
    }
  }, [_c('b-input', {
    staticClass: "count",
    attrs: {
      "placeholder": "0",
      "type": "number"
    },
    on: {
      "change": _vm.handleUpdateWebinar
    },
    model: {
      value: (_vm.webinarObject.places),
      callback: function($$v) {
        _vm.$set(_vm.webinarObject, "places", $$v)
      },
      expression: "webinarObject.places"
    }
  }), _vm._v(" "), (_vm.webinarObject.webinarParticipants && _vm.webinarObject.webinarParticipants.length) ? _c('a', {
    staticClass: "button is-info",
    on: {
      "click": _vm.showParticipants
    }
  }, [_vm._v("\n          Посмотреть " + _vm._s(_vm.webinarObject.webinarParticipants.length) + " " + _vm._s(_vm.requestDeclension) + "\n        ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Дата и время вебинара"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "editable": false,
      "type": "datetime",
      "placeholder": "00:00"
    },
    on: {
      "change": _vm.dateChanged
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Тема вебинара"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Напишите тему"
    },
    on: {
      "change": _vm.handleUpdateWebinar
    },
    model: {
      value: (_vm.webinarObject.theme),
      callback: function($$v) {
        _vm.$set(_vm.webinarObject, "theme", $$v)
      },
      expression: "webinarObject.theme"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Ссылка"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Ссылка"
    },
    on: {
      "change": _vm.handleUpdateWebinar
    },
    model: {
      value: (_vm.webinarObject.link),
      callback: function($$v) {
        _vm.$set(_vm.webinarObject, "link", $$v)
      },
      expression: "webinarObject.link"
    }
  })], 1), _vm._v(" "), (_vm.webinarObject.webinarSpeaker) ? _c('div', [_c('b-field', {
    staticClass: "webinar-description",
    attrs: {
      "label": "О чем вебинар"
    }
  }, [_c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "id": "q" + _vm.webinarObject.id,
      "placeholder": ""
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Выбрать спикера"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Выбрать спикера"
    },
    on: {
      "change": _vm.changeSpeaker
    },
    model: {
      value: (_vm.speaker),
      callback: function($$v) {
        _vm.speaker = $$v
      },
      expression: "speaker"
    }
  }, _vm._l((_vm.speakers), function(speaker) {
    return _c('el-option', {
      key: speaker.id,
      attrs: {
        "label": speaker.name,
        "value": speaker.id
      }
    })
  }), 1)], 1)], 1) : _c('div', {
    staticClass: "webinar-meta"
  }, [_c('div', {
    staticClass: "description-entry"
  }, [_c('b-field', {
    staticClass: "webinar-description",
    attrs: {
      "label": "Название доклада"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Название доклада"
    },
    on: {
      "change": _vm.handleUpdateWebinar
    },
    model: {
      value: (_vm.presentation0),
      callback: function($$v) {
        _vm.presentation0 = $$v
      },
      expression: "presentation0"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    staticClass: "webinar-description",
    attrs: {
      "label": "Основные тезисы"
    }
  }, [_c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar0,
      "id": "q0" + _vm.webinarObject.id,
      "placeholder": ""
    },
    model: {
      value: (_vm.description0),
      callback: function($$v) {
        _vm.description0 = $$v
      },
      expression: "description0"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Выбрать спикеров"
    }
  }, [_c('el-select', {
    staticClass: "centered",
    attrs: {
      "multiple": "",
      "placeholder": "Выбрать спикеров"
    },
    on: {
      "change": _vm.handleUpdateWebinar
    },
    model: {
      value: (_vm.selectedSpeakers0),
      callback: function($$v) {
        _vm.selectedSpeakers0 = $$v
      },
      expression: "selectedSpeakers0"
    }
  }, _vm._l((_vm.speakers), function(speaker) {
    return _c('el-option', {
      key: speaker.id,
      attrs: {
        "label": speaker.name,
        "value": speaker.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "description-entry"
  }, [_c('b-field', {
    staticClass: "webinar-description",
    attrs: {
      "label": "Название доклада"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Название доклада"
    },
    on: {
      "change": _vm.handleUpdateWebinar
    },
    model: {
      value: (_vm.presentation1),
      callback: function($$v) {
        _vm.presentation1 = $$v
      },
      expression: "presentation1"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    staticClass: "webinar-description",
    attrs: {
      "label": "Основные тезисы"
    }
  }, [_c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar1,
      "id": "q1" + _vm.webinarObject.id,
      "placeholder": ""
    },
    model: {
      value: (_vm.description1),
      callback: function($$v) {
        _vm.description1 = $$v
      },
      expression: "description1"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Выбрать спикеров"
    }
  }, [_c('el-select', {
    staticClass: "centered",
    attrs: {
      "multiple": "",
      "placeholder": "Выбрать спикеров"
    },
    on: {
      "change": _vm.handleUpdateWebinar
    },
    model: {
      value: (_vm.selectedSpeakers1),
      callback: function($$v) {
        _vm.selectedSpeakers1 = $$v
      },
      expression: "selectedSpeakers1"
    }
  }, _vm._l((_vm.speakers), function(speaker) {
    return _c('el-option', {
      key: speaker.id,
      attrs: {
        "label": speaker.name,
        "value": speaker.id
      }
    })
  }), 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrapper"
  }, [_c('b-switch', {
    on: {
      "change": _vm.handleUpdateWebinar
    },
    model: {
      value: (_vm.webinarObject.publishLater),
      callback: function($$v) {
        _vm.$set(_vm.webinarObject, "publishLater", $$v)
      },
      expression: "webinarObject.publishLater"
    }
  }, [_vm._v("Опубликовать позже")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "editable": false,
      "type": "date",
      "placeholder": "00:00"
    },
    on: {
      "change": _vm.publishDateChanged
    },
    model: {
      value: (_vm.publishDate),
      callback: function($$v) {
        _vm.publishDate = $$v
      },
      expression: "publishDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "save-content-button centered"
  }, [_c('div', {
    staticClass: "button save-content",
    on: {
      "click": _vm.handleSaveWebinar
    }
  }, [_vm._v("СОХРАНИТЬ")])])], 1), _vm._v(" "), (_vm.webinarObject.webinarParticipants) ? _c('el-dialog', {
    staticClass: "webinar-dialog",
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "webinar-participants"
  }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.webinarObject.theme) + "\n      ")]), _vm._v(" "), _c('span', [_vm._v("\n        " + _vm._s(_vm.formatedDate) + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "webinar-participants-count"
  }, [_vm._v("\n        " + _vm._s(_vm.webinarObject.webinarParticipants.length) + " " + _vm._s(_vm.requestDeclension) + "\n      ")]), _vm._v(" "), _c('table', {
    staticClass: "webinar-table"
  }, _vm._l((_vm.webinarObject.webinarParticipants), function(participant) {
    return _c('tr', [_c('td', {
      staticClass: "name"
    }, [_vm._v(" " + _vm._s(participant.name))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(participant.phone))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(participant.email))])])
  }), 0)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35197516"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/Webinar.vue
// module id = 927
// module chunks = 0